import React, { useState } from 'react';
import { Message } from '@shopee/chatbot-ui';
import { ChatbotUIBasicProps } from '@/types/common';
import { ButtonAction, ButtonType, getButtonAction, getButtonType } from '@/utils/getButtonData';
import { IntentSource, TRACKING_MSG_TYPE, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';

import './style.scss';
import { afterDialogueShow } from '@/utils/tools';

export enum IntentSelectorDisplayType {
  normal,
  Delay,
  Collapse,
}

export type Props = {
  content: string;
  displayType: number;
  intents: {
    bot_id: number;
    intent_id: number;
    intent_name: string;
    query_callback: any;
  }[];
  extraInfo: {
    thread_id_v2: string | number;
    round_id: string | number;
  };
} & ChatbotUIBasicProps;

const OrderListIntentSelector: React.FC<Props> = (props) => {
  const { extraInfo, customCallback = {} } = props;
  const displayType = formatDisplayType(props.displayType);
  const collapse = displayType === IntentSelectorDisplayType.Collapse && !props.isHistory;
  const [buttonsDisabled, setButtonsDisabled] = useState(Array(props?.intents?.length ?? 0).fill(false)); // 记录 按钮的 disabled

  const setButtonDisabled = (i: number) => { // 当点击 这个 intent 之后 需要置灰 不可再点击 产品新增需求
    const newButtonsDisabled = [...buttonsDisabled];
    newButtonsDisabled[i] = true;
    setButtonsDisabled(newButtonsDisabled);
  };

  const buttonGroup = {
    layout: 'vertical',
    buttons: props?.intents?.map((intent, index) => ({
      type: getButtonType(ButtonType.Link),
      text: intent.intent_name,
      action: {
        ...intent,
        func: getButtonAction(ButtonAction.JumpIntentUseMessage),
        info: props,
        nextParams: {
          ...(intent.query_callback ?? {}),
          thread_id_v2: extraInfo?.thread_id_v2,
          round_id: extraInfo?.round_id,
          input_type: 1,
          message_extra: { intent_id: intent?.intent_id + '' },
          dialogue_id: props?.dialogueId,
        },
        customCallback,
      },
      disabled: props.isHistory || buttonsDisabled[index],
      trackingData: {
        trackingsection: TRACKING_SECTION[TRACKING_TYPE.ADDITIONAL_OPTION_QUESTION],
        trackingtarget: TRACKING_TARGET[TRACKING_TYPE.ADDITIONAL_OPTION_QUESTION],
        trackingdataBasic: {
          chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
          chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
          bot_id: props.kbBotId,
          bot_name: props.kbBotName,
          if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
          button_name: intent.intent_name,
          intent_id: intent.intent_id,
        },
      },
      onClick: () => {
        // 当该 intent 点击之后 置灰
        setButtonDisabled(index);
      },
    })),
  };

  return (
    <Message
      className="order-list-intent-selector"
      content={props.content}
      collapse={collapse}
      buttonGroup={buttonGroup as any}
      onCollapseClick={afterDialogueShow}
      collapseTrackingData={{
        trackingsection: TRACKING_SECTION[TRACKING_TYPE.ADDITIONAL_OPTION_BUTTON],
        trackingtarget: TRACKING_TARGET[TRACKING_TYPE.ADDITIONAL_OPTION_BUTTON],
        trackingdataBasic: {
          chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
          chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
          bot_id: props.kbBotId,
          bot_name: props.kbBotName,
          if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
          button_name: 'expand_button',
        },
      }}
    />
  );
};

export function formatDisplayType(displayType: number) {
  if (displayType === 1 || displayType === 3) {
    return IntentSelectorDisplayType.Delay;
  } else if (displayType === 2) {
    return IntentSelectorDisplayType.Collapse;
  } else {
    return IntentSelectorDisplayType.normal;
  }
}

export default OrderListIntentSelector;
